var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 40,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      !_vm.isReactivateInvoice
                        ? "Submit Tax Invoice"
                        : "Submit Re-activate Invoice"
                    )
                  ),
                ]),
              ]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { staticClass: "field box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                      "show-pagination": false,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.invoices, function (invoice, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              `${invoice.prefix}${invoice.invoiceNo}${invoice.suffix}/${invoice.invoiceType}`
                            )
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatDateLocale(
                                invoice.invoiceDate,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.value.quoteNo))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                invoice.totalIncGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                invoice.gst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                invoice.totalExGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass:
                              "has-text-centered has-vertical-middle is-content-width",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: invoice.isSelected,
                                      expression: "invoice.isSelected",
                                    },
                                  ],
                                  staticClass: "is-checkradio is-primary",
                                  attrs: {
                                    id: `orm-invoice-select${index}`,
                                    name: `orm-invoice-select${index}`,
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(invoice.isSelected)
                                      ? _vm._i(invoice.isSelected, null) > -1
                                      : invoice.isSelected,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectInvoice(
                                        invoice.invoiceId
                                      )
                                    },
                                    change: function ($event) {
                                      var $$a = invoice.isSelected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              invoice,
                                              "isSelected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              invoice,
                                              "isSelected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(invoice, "isSelected", $$c)
                                      }
                                    },
                                  },
                                }),
                                _c("label", {
                                  attrs: {
                                    for: `orm-invoice-select${index}`,
                                    "data-label-empty": "",
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.value.subQuoteNo > 0,
                    expression: "value.subQuoteNo > 0",
                  },
                ],
                staticClass: "field box",
              },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Invoice Reason"),
                ]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.submitTaxInvoiceModel.invoiceReason,
                      expression: "submitTaxInvoiceModel.invoiceReason",
                    },
                  ],
                  staticClass: "textarea",
                  attrs: { rows: "3" },
                  domProps: { value: _vm.submitTaxInvoiceModel.invoiceReason },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.submitTaxInvoiceModel,
                        "invoiceReason",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isQuoteSubmitted || _vm.isInvoiceSubmitted,
                    expression: "isQuoteSubmitted || isInvoiceSubmitted",
                  },
                ],
                staticClass: "field box",
              },
              [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isQuoteSubmitted,
                          expression: "isQuoteSubmitted",
                        },
                      ],
                      staticClass: "has-text-danger",
                    },
                    [
                      _vm._v(
                        " Quote is in submitted stage. IT'S STRONGLY RECCOMMEND THAT YOU CHECK YOUR MAILBOX FOR THE EXPECTED AUTHORISATION MESSAGE AND LOAD IT INTO THIS QUOTE BEFORE YOU SEND TAX INVOICE "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isInvoiceSubmitted,
                          expression: "isInvoiceSubmitted",
                        },
                      ],
                      staticClass: "has-text-danger",
                    },
                    [
                      _vm._v(
                        " Invoice is in submitted stage. YOU HAVE ALREADY SENT THE INVOICE FOR THIS QUOTE. IT'S STRONGLY RECCOMMEND THAT YOU RE-ACTIVATE THE TAX INVOICE "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isQuoteSubmitted || _vm.isInvoiceSubmitted,
                        expression: "isQuoteSubmitted || isInvoiceSubmitted",
                      },
                    ],
                    staticClass: "control",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.submitTaxInvoiceModel.isSendOverride,
                          expression: "submitTaxInvoiceModel.isSendOverride",
                        },
                      ],
                      staticClass: "is-checkradio is-primary",
                      attrs: {
                        id: `orm-invoice-override`,
                        name: `orm-invoice-override`,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.submitTaxInvoiceModel.isSendOverride
                        )
                          ? _vm._i(
                              _vm.submitTaxInvoiceModel.isSendOverride,
                              null
                            ) > -1
                          : _vm.submitTaxInvoiceModel.isSendOverride,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.submitTaxInvoiceModel.isSendOverride,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.submitTaxInvoiceModel,
                                  "isSendOverride",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.submitTaxInvoiceModel,
                                  "isSendOverride",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.submitTaxInvoiceModel,
                              "isSendOverride",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: `orm-invoice-override` } }, [
                      _vm._v("Proceed with sending this Invoice regardless"),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Send Tax Invoice",
                    disabled: !_vm.canSubmit,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.send()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                  ]),
                  _c("span", [_vm._v("Send")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }